export default __webpack_public_path__ + "static/media/LavieSport1.1007e596.jpg";